import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { useCallback } from 'react';
import { FormControlContainer } from '../../../components/formControlContainer';
import { isConfigFlagEnabled } from '../../../config';
import { setCreateGameIsSideBetsPhaseEnabled } from '../../../redux/actions/createGameActions';
import { useAppDispatch, useAppSelector } from '../../../redux/store';
export const SideBetsPhaseControl = () => {
    const dispatch = useAppDispatch();
    const isSideBetsPhaseEnabled = useAppSelector((state) => state.createGame.isSideBetsPhaseEnabled);
    const roomType = useAppSelector((state) => state.createGame.roomType);
    const onChange = useCallback((event) => {
        dispatch(setCreateGameIsSideBetsPhaseEnabled(event.target.checked));
    }, [dispatch]);
    if (!isConfigFlagEnabled('sideBets')) {
        return null;
    }
    if (roomType !== 'regular') {
        // control not relevant
        return null;
    }
    return (_jsxs(FormControlContainer, { isFlex: true, children: [_jsx(FormControl, { component: 'fieldset', children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: isSideBetsPhaseEnabled, onChange: onChange }), label: 'Side Bet Phase' }) }), _jsx(Typography, { variant: 'subtitle2', component: 'div', children: "When on, there may be an additional phase before players' cards are revealed to allow for any last-second side bets." })] }));
};
